import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";

export default function HomeRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
    </Routes>
  );
}
